<article
	cdkDropList
	cdkDropListOrientation="horizontal"
	(cdkDropListDropped)="onMoveColumn($event)"
	class="Table__container Spinner-container"
	[style.height]="tableHeight"
>
	<section class="Table">
		<!-- Content -->
		<section
			class="Table__content"
			[class.Table__content--actions]="hasActions()"
			[class.Table__content--selects]="hasSelects"
		>
			<section
				cdkDrag
				cdkDragPreviewContainer="parent"
				*ngFor="let column of dragAndDropColumnsToShowed()"
				class="Table__column"
				[style.flexBasis]="column.width"
				[style.flexShrink]="column.width === 'auto' ? '1' : '0'"
				[style.flexGrow]="column.width === 'auto' ? '1' : '0'"
			>
				<section class="Table__header">
					<app-icon
						cdkDragHandle
						matTooltip="Drag"
						matTooltipClass="Tooltip"
						iconSize="normal"
						spaceDirection="right"
						[icon]="EIcons.gripVerticalSolid"
					/>

					<span>{{ column.label }}</span>
				</section>
				<section
					*ngFor="let value of column.values"
					class="Table__cell"
                    [style]="column.cssVariables(value)"
					[style.justifyContent]="column.justify"
					[style.textAlign]="column.justify"
				>
					<ng-container [ngSwitch]="true">
						<!-- Has Pill -->
						<ng-container *ngSwitchCase="column.isPill">
							<ng-container
								*ngIf="
									column.transform(value) !== null &&
										column.transform(value) !== undefined &&
										column.transform(value) !== '';
									else elseColumnTransform
								"
							>
								<app-pill [value]="column.transform(value)" />
							</ng-container>
						</ng-container>
						<!-- Default -->
						<ng-container *ngSwitchDefault>
							<ng-container
								*ngIf="
									column.transform(value) !== null &&
										column.transform(value) !== undefined &&
										column.transform(value) !== '';
									else elseColumnTransform
								"
							>
								<span>{{ column.transform(value) }}</span>
							</ng-container>
						</ng-container>
						<!-- Else Transform -->
						<ng-template #elseColumnTransform> - </ng-template>
					</ng-container>
				</section>
			</section>
		</section>
		<!-- Actions -->
		<section
			*ngIf="hasActionsOrSelects && dragAndDropColumnsToShowedLength()"
			class="Table__column"
			[class.Table__column--actions]="hasActions()"
			[class.Table__column--selects]="hasSelects"
		>
			<section
				class="Table__header"
				[class.Table__header--actions]="hasActions()"
				[class.Table__header--selects]="hasSelects"
			>
				<!-- Select All Checkbox -->
				<mat-checkbox
					*ngIf="hasSelectsAll"
					color="primary"
					matTooltip="Todo"
					matTooltipClass="Tooltip"
					class="Checkbox"
					[checked]="
						dragAndDropColumnSelected().length === dragAndDropColumns().at(0)?.values?.length
					"
					[indeterminate]="
						!!dragAndDropColumnSelected().length &&
						dragAndDropColumnSelected().length !== dragAndDropColumns().at(0)?.values?.length
					"
					(change)="onSelectOrUnselectAll($event, dragAndDropColumns())"
				/>
			</section>
			<section
				*ngFor="let value of dragAndDropColumnsToShowed()?.at(0)?.values; let index = index"
				class="Table__cell Table__cell--actions"
			>
				<div class="Utils__display-flex">
					<!-- Select Checkbox -->
					<mat-checkbox
						*ngIf="hasSelects"
						color="primary"
						class="Checkbox"
						matTooltip="Seleccionar"
						matTooltipClass="Tooltip"
						[checked]="isSelected(dragAndDropColumns(), index)"
						(change)="onSelect($event, dragAndDropColumns(), index)"
					/>

					<!-- Menu Button -->
					<app-icon-button
						*ngIf="hasActions()"
						buttonSize="normal"
						[hasBackground]="true"
						[matMenuTriggerFor]="menuEditAndDelete"
					>
						<app-icon
							appIcon
							[icon]="EIcons.ellipsisVerticalSolid"
							iconSize="normal"
							[iconMoveTopToBotton]="1"
						/>
					</app-icon-button>
				</div>

				<!-- Menu Edit & Delete -->
				<mat-menu #menuEditAndDelete="matMenu" class="Menu">
					<ng-container *ngFor="let action of actions()">
						<button
							*ngIf="action.showWhen(rebuildDataStructure(index))"
							mat-menu-item
							class="Menu__item Menu__item--isFull {{ action.classColor }}"
							(click)="onEmitAction(action, dragAndDropColumns(), index)"
						>
							<app-icon [icon]="action.icon" iconSize="normal" [iconMoveTopToBotton]="1" />
							{{ action.label }}
						</button>
					</ng-container>
				</mat-menu>
			</section>
		</section>
	</section>

	<section *ngIf="!dragAndDropColumnsToShowedLength()" class="Table__empty">
		{{ emptyMessage ? emptyMessage : 'We have not data to show yet!' }}
	</section>

	<section *ngIf="isLoading && dragAndDropColumnsToShowedLength()" class="Spinner-overlay">
		<mat-spinner matPrefix color="primary" [diameter]="100"></mat-spinner>
	</section>
</article>

